exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".tab-sticky[data-v-9a3e903e]{position:-webkit-sticky!important;position:sticky!important;top:122px!important;z-index:98}", ""]);

// exports
